<template>
  <div>
    <div v-if="loading || connecting" class="ui active dimmer">
      <div class="ui text loader">{{$t('Loading')}}</div>
    </div>
    <div class="ui info message">      
      <p>{{$t('guide',{deviceName})}}</p>
    </div>
    <div class="ui stackable centered relaxed grid">
      <VideoThumb class="four wide column" v-for="(video, index) in videos" :key="video.key"
        :title="video.title"
        :thumbnail="video.thumbnail"
        :created="video.created"
        @click="playAt(index)"></VideoThumb>
    </div>
    <LoginGuide ref="loginGuide" :message="$t('In order to play this video on the device, you need to sing in to EZCast and register this device.', {keySeparator:'#'})"/>
  </div>
</template>

<script>
import VideoThumb from './VideoThumb';
import LoginGuide from './LoginGuide';
import { mapState } from 'vuex';
import JRPC from 'jrpc';

const gtag = window.gtag;

export default {
  data () {
    return {
      connecting: false,
      deviceName: undefined,
    };
  },
  computed: {
    loading () {
      return this.exception == undefined && this.videos == undefined;
    },
    ...mapState([
      'videos',
      'exception',
      'isLoggedInUser',
      'videoSource',
    ]),
  },
  mounted () {
    // this.logVisitedIfNeeded();
    (async () => {
      if (this.exception) { // skip following operations when exception occurs when initialization
        throw this.exception;
      }
      const urlParams = new URLSearchParams(window.location.search);
      this.deviceName = urlParams.get('dn') || urlParams.get('did');
      const access_token = urlParams.get('access_token');
      if (access_token) {
        const did = urlParams.get('did');
        const eznodeBaseUrl = process.env.VUE_APP_EZNODE_BASE_URL || 'https://eznode.iezvu.com';
        // eslint-disable-next-line no-undef
        const primus = this.primus = Primus.connect(`${eznodeBaseUrl}/cloudControl?access_token=${access_token}&did=${did}`);
        const remote = this.remote = new JRPC({
          remoteTimeout: 6,
        });
        remote.setTransmitter((msg, next) => {
          try {
            primus.write(JSON.parse(msg));
            return next(undefined);
          } catch (e) {
            return next(e);
          }
        });
        primus.on('open', () => {
          // eslint-disable-next-line no-unused-vars
          remote.call('hello', {}, (err, feedback) => {
          });
        });
        primus.on('data', function message(data) {
          remote.receive(data);
        });
      }
    })()
    .catch(() => {});
  },
  methods: {
    playAt(index) {
      const urlParams = new URLSearchParams(window.location.search);
      const playPlaylist = () => {
        if (!this.isLoggedInUser && urlParams.get('redirect_url')) {        
          this.$refs.loginGuide.show();
          return;
        }
        const playlist = this.videos.map((video) => {
          return Object.assign({
            source_type: 'html',
            image: video.thumbnail,
          }, video);
        });
        this.connecting = true;
        this.remote.call('playPlaylist', { 
          playlist: {
            status: true,
            // update: moment().format('YYYY-M-D H:m:s'),
            item_per_page: playlist.length,
            total_item: playlist.length,
            // repeat_all: false,
            channel_name: 'Recommendations',
            playlist,
            // next_page: null,
          },
          startIndex: index,
          origin: 'user' 
        }, (err) => {
          this.connecting = false;
          if (err) {
            gtag('event', 'exception', {
              description: `play_playlist_failed. ${JSON.stringify(err)}`,
              fatal: false,
            });
            return window.$(this.$refs.errorDialog).modal('show');
          } else {
            gtag('event', 'view_item');
          }
          const access_token = urlParams.get('access_token');
          const did = urlParams.get('did');
          const deviceName = urlParams.get('dn');
          const eznodeBaseUrl = process.env.VUE_APP_EZNODE_BASE_URL || 'https://eznode.iezvu.com';
          location.href = `${eznodeBaseUrl}/cloudControl/?did=${did}&access_token=${access_token}&dn=${deviceName}`;
        });
      };
      gtag('event', 'select_content', {
        content_type : this.videoSource || 'recommendation',
        event_callback: playPlaylist,
      });
    },
  },
  components: {
    VideoThumb,
    LoginGuide,
  },
}
</script>
